import { useEffect, useRef, useState } from 'react';

const useComponentLazyLoad = () => {
  const [isInViewport, setIsInViewport] = useState(false);
  const elementRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const element = elementRef.current;
    if (!element || isInViewport) return;

    const observer = new IntersectionObserver(
      entries => {
        // Check if the element is in the viewport
        if (entries[0].isIntersecting) {
          setIsInViewport(true);
        } else {
          setIsInViewport(false);
        }
      },
      {
        root: null, // Use the viewport as the root
        rootMargin: '0px 0px 100px 0px', // Adjust this value to trigger the intersection event earlier or later
        threshold: 0.5, // 0.5 means at least 50% of the element must be visible to trigger the event
      },
    );

    observer.observe(element);

    // eslint-disable-next-line consistent-return
    return () => {
      observer.unobserve(element);
    };
  }, [isInViewport]);

  return {
    isInViewport,
    elementRef,
  };
};

export default useComponentLazyLoad;
